import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { User } from '../../utils/backend-api/currentUser';
import Layout from './Layout';

const queryClient = new QueryClient();

interface TopEntity {
  id: number;
  name: string;
  following: boolean;
}
type MatchingEntity = Omit<TopEntity, 'following'>;

export interface SearchPageProps {
  customBlurb?: string;
  followCount?: number;
  followers?: Array<User>;
  followStatus?: boolean;
  isSignedIn: boolean;
  matchingEntity?: MatchingEntity;
  numArticleResults?: number;
  page: number;
  query?: string;
  scope: string;
  title: string;
  topEntities?: Array<TopEntity>;
  topRelatedEntities: Array<string>;
}

const SearchPage = ({
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  numArticleResults,
  page,
  query,
  scope,
  title,
  topEntities,
  topRelatedEntities,
}: SearchPageProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Layout
        customBlurb={customBlurb}
        followCount={followCount}
        followers={followers}
        followStatus={followStatus}
        isSignedIn={isSignedIn}
        matchingEntity={matchingEntity}
        numArticleResults={numArticleResults}
        page={page}
        query={query}
        scope={scope}
        title={title}
        topEntities={topEntities}
        topRelatedEntities={topRelatedEntities}
      />
    </QueryClientProvider>
  );
};

export default SearchPage;
